module.exports = __webpack_public_path__ + "src/app/assets/images/speakers/dotta.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/speakers/dotta.jpg
// module id = 608
// module chunks = 0